import { useTranslation } from "react-i18next"

import type { AdminAreaId } from "../admin-dashboard-route-state"
import type { AdminAreaEntry } from "../admin-search-registry"

import { ADMIN_AREA_ENTRIES } from "../admin-search-registry"
import { AdminSubNavigation } from "./admin-sub-navigation"

type AdminWorkspaceNavigationProps = {
  activeArea: AdminAreaId
  /** Capability-filtered areas — the same list the page navigates within. */
  areas?: AdminAreaEntry[]
  onAreaChange: (area: AdminAreaId) => void
}

export function AdminWorkspaceNavigation({
  activeArea,
  areas = ADMIN_AREA_ENTRIES,
  onAreaChange,
}: AdminWorkspaceNavigationProps) {
  const { t } = useTranslation()

  return (
    <AdminSubNavigation
      fillAvailableWidth
      ariaLabel={t("adminDashboard.workspaceNavigation.areasAriaLabel", "Admin areas")}
      mobileLabel={t("adminDashboard.workspaceNavigation.areaMobileLabel", "Admin area")}
      mobileTestId="admin-area-select"
      navigationTestId="admin-area-navigation"
      value={activeArea}
      options={areas.map((option) => ({
        id: option.id,
        icon: option.icon,
        label: t(option.labelKey, option.labelFallback),
      }))}
      onValueChange={(value) => onAreaChange(value as AdminAreaId)}
    />
  )
}
